import React from "react";

import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./components/protected-route/protected-route";
import AuthedPageLayout from "./components/authed-page/authed-page-layout";
import Dashboard from "./pages/dashboard/dashboard";
import ClientPage from "./pages/clients/clients-page";
import { AuthProvider } from "./context/Auth/auth-context";
import Login from "./pages/login/login";
import TowersPage from "./pages/towers/towers-page";
import ClientTransactions from "./pages/client-transactions/client-transactions";
import "react-toastify/dist/ReactToastify.css";
import { successToastContainerId, errorToastContainerId } from "./utils/toast";
import { SidebarProvider } from "./context/sidebar";
import { adminOnly, internalUsers, everyone } from "./utils/roles";
import MyProfile from "./pages/my-profile/my-profile";
import MyHistory from "./pages/my-history/my-history";
import MyPower from "./pages/my-power/my-power";
import Packages from "./pages/packages/Packages";
import RecentTransactions from "./pages/recent-transactions/RecentTransactions";
import UsersPage from "./pages/users/users";
import { ToastContainer, Zoom } from "react-toastify";
import Notification from "./firebaseNotifications/Notification";
import TopUp from "./pages/top-up/top-up";
import PaymentResult from "./pages/payment-result/payment-result";
import PaymentSuccess from "./pages/payment-success/payment-success";
import TermsAndConditionsPage from "./pages/terms-and-conditions/terms-and-conditions";
import Grids from "./pages/grids/grids";
import PublicTopUp from "./pages/public-top-up/public-top-up";
import Landing from "./pages/landing/landing";
import BankingApp from "./pages/banking-app/banking-app";
import { ADMIN_LOGIN } from "./utils/routes";
function App() {
  console.log("here");
  return (
    <>
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        transition={Zoom}
        closeButton={false}
      />
      {/* These sit outside the routes so the public top-up pages get them
          too. react-toastify only shows a toast in the container whose id
          it names, so without them those toasts went nowhere. */}
      <ToastContainer
        hideProgressBar={true}
        autoClose={1500}
        containerId={successToastContainerId}
        toastClassName="body-color"
        progressClassName="progress"
      />
      <ToastContainer
        hideProgressBar={true}
        autoClose={false}
        containerId={errorToastContainerId}
        toastClassName="body-color"
        progressClassName="progress"
      />

      <Routes>
        <Route
          path="/terms-and-conditions"
          element={<TermsAndConditionsPage />}
        />
        <Route path="/" element={<Landing />} />
        <Route path="/topup" element={<PublicTopUp />} />
        <Route path="/banking-app" element={<BankingApp />} />
        {/* Ozow sends the payer back here. Agents pay for clients without
            logging in, so these pages must not sit behind a login. */}
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/error" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentResult />} />
        <Route
          path="/*"
          element={
            <SidebarProvider>
              <AuthProvider>
                <Notification />
                <div className="main-app">
                  <Routes>
                    <Route path={ADMIN_LOGIN} element={<Login />} />
                    {/* Anyone with the old link still lands on it. */}
                    <Route
                      path="/login"
                      element={<Navigate replace to={ADMIN_LOGIN} />}
                    />
                    <Route
                      path="dashboard"
                      element={
                        <ProtectedRoute allowedRoles={adminOnly}>
                          <AuthedPageLayout>
                            <Dashboard />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="clients-dashboard"
                      element={
                        <ProtectedRoute allowedRoles={internalUsers}>
                          <AuthedPageLayout>
                            <ClientPage />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="meters"
                      element={
                        <ProtectedRoute allowedRoles={internalUsers}>
                          <AuthedPageLayout>
                            <TowersPage />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="users"
                      element={
                        <ProtectedRoute allowedRoles={adminOnly}>
                          <AuthedPageLayout>
                            <UsersPage />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="grids"
                      element={
                        <ProtectedRoute allowedRoles={internalUsers}>
                          <AuthedPageLayout>
                            <Grids />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="revenue/recent-transactions"
                      element={
                        <ProtectedRoute allowedRoles={adminOnly}>
                          <AuthedPageLayout>
                            <RecentTransactions />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="packages"
                      element={
                        <ProtectedRoute allowedRoles={internalUsers}>
                          <AuthedPageLayout>
                            <Packages />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="communication"
                      element={
                        <ProtectedRoute allowedRoles={internalUsers}>
                          <AuthedPageLayout>
                            <Dashboard />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="appliances"
                      element={
                        <ProtectedRoute allowedRoles={internalUsers}>
                          <AuthedPageLayout>
                            <Dashboard />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="client-details/:id"
                      element={
                        <ProtectedRoute allowedRoles={internalUsers}>
                          <AuthedPageLayout>
                            <ClientTransactions />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="my-profile"
                      element={
                        <ProtectedRoute allowedRoles={everyone}>
                          <AuthedPageLayout>
                            <MyProfile />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="my-history"
                      element={
                        <ProtectedRoute allowedRoles={everyone}>
                          <AuthedPageLayout>
                            <MyHistory />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="my-power"
                      element={
                        <ProtectedRoute allowedRoles={everyone}>
                          <AuthedPageLayout>
                            <MyPower />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="top-up"
                      element={
                        <ProtectedRoute allowedRoles={everyone}>
                          <AuthedPageLayout>
                            <TopUp />
                          </AuthedPageLayout>
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </div>
              </AuthProvider>
            </SidebarProvider>
          }
        />
      </Routes>
    </>
  );
}

export default App;
